import { type HistoryGroup } from "@/features/history/utils";
import { type History } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateKey } from "@repo/ui";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
}

export const TitleHistoryItem = ({ history }: Props) => {
  return (
    <HistoryListViewItem
      history={history}
      control="default"
      title={translateKey(history.title) ?? ""}
      description={
        <div>
          <Text textStyle="Body.S">
            {t("label.history_previous_title")}{" "}
            {(history.details?.old_value as string) || ""}
          </Text>
          <Text textStyle="Body.S">
            {t("label.history_new_title")}{" "}
            {(history.details?.new_value as string) || ""}
          </Text>
        </div>
      }
    />
  );
};
